module.exports = __webpack_public_path__ + "img/icon1@3x.0aeabc26.png";